<template>
  <app-layout>
    <div
      class="min-h-screen py-12 px-4 sm:px-6 lg:px-8 flex flex-col justify-center items-center"
    >
      <p class="text-3xl text-center mt-5 mb-0">
        <i class="fas fa-times-circle text-red-500 mr-2" />
        Ops, your purchase has been canceled.
      </p>

      <p class="text-xl text-center mt-2">
        If you are experiencing any trouble, <br />please
        contact us via
        <a
          href="mailto: support@scaffoldhub.io"
          class="text-bold"
          >support@scaffoldhub.io</a
        >.
      </p>

      <router-link to="/pricing" class="mt-5 text-blue-600">
        Back to pricing page
      </router-link>
    </div>
  </app-layout>
</template>

<script>
export default {};
</script>

<style></style>
